module.exports = __webpack_public_path__ + "img/26.21971b69.png";